import { SupplierProfilePatchDto } from './supplier-profile-patch-dto.model';

export class SupplierProfileDto {
	public companyName: string;
	public adminEmail: string;
	public kvkNumber: string;
	public supplierProfilePatchDto: SupplierProfilePatchDto;
}
